/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyertitleplaceholder2Inputs */

const en_flyertitleplaceholder2 = /** @type {(inputs: Flyertitleplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summer party 2026`)
};

const de_flyertitleplaceholder2 = /** @type {(inputs: Flyertitleplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sommerfest 2026`)
};

/**
* | output |
* | --- |
* | "Summer party 2026" |
*
* @param {Flyertitleplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyertitleplaceholder2 = /** @type {((inputs?: Flyertitleplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyertitleplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyertitleplaceholder2(inputs)
	return de_flyertitleplaceholder2(inputs)
});
export { flyertitleplaceholder2 as "flyerTitlePlaceholder" }